import { formatMetric } from "../utils/formatters";

export type HeaderKey = "ordersAmount" | "drr" | "ctr" | "cpc";

export interface Header {
  key: HeaderKey;
  label: string;
  suffix?: string;
}

export const HEADERS: readonly Header[] = [
  { key: "ordersAmount", label: "Заказы" },
  { key: "drr", label: "ДРР" },
  { key: "ctr", label: "CTR" },
  { key: "cpc", label: "CPC" },
];

export const METRIC_TYPES: Record<
  HeaderKey,
  Parameters<typeof formatMetric>[1]
> = {
  ordersAmount: "orders",
  drr: "percent",
  ctr: "percent",
  cpc: "currency",
};
